import { render } from "./DashboardMain.vue?vue&type=template&id=aa55d3fa&scoped=true"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"

import "./DashboardMain.vue?vue&type=style&index=0&id=aa55d3fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa55d3fa"]])

export default __exports__